import React, { useCallback } from 'react';
import { menuSectionStore } from '../../../../../store/menuSectionStore';
import Button from '../../../button';
import { applicationStore } from '../../../../../store/applicationStore';

function GameRulesFooter({ x, y }) {
  const { setIsShowMenuPopup } = menuSectionStore;

  const handleClickPlayButton = useCallback(() => {
    setIsShowMenuPopup(false);
  }, [setIsShowMenuPopup]);

  return (
    <Button
      x={x}
      y={y}
      name='GameRulesFooter'
      buttonText={applicationStore.canvasTranslationKeys.PLAY}
      textStyles={{
        _fontSize: 20,
        _fontWeight: 500,
        _fill: '#FFFFFF',
        _fontFamily: 'poppinsMedium',
      }}
      handleClickButton={handleClickPlayButton}
    />
  );
}
export default GameRulesFooter;
